"use client";

import { useSecureCookies } from "@pharaday/auth";
import { useReactiveCookiesNext } from "cookies-next";
import { useCallback } from "react";

import { NamespaceProvider } from "../core";

const COOKIE_OPTIONS = {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  secure: useSecureCookies(),
  sameSite: "lax" as const,
  path: "/",
};

const useNamespaceId = () => {
  const { getCookie, setCookie, deleteCookie, revalidateCookiesState } = useReactiveCookiesNext();

  const namespaceId = getCookie(NamespaceProvider.COOKIE_NAMESPACE_ID);

  const setNamespaceId = useCallback(
    (namespaceId: string) => {
      setCookie(NamespaceProvider.COOKIE_NAMESPACE_ID, namespaceId, COOKIE_OPTIONS);
      revalidateCookiesState();
    },
    [revalidateCookiesState, setCookie]
  );

  const resetNamespaceId = useCallback(() => {
    deleteCookie(NamespaceProvider.COOKIE_NAMESPACE_ID, COOKIE_OPTIONS);
    revalidateCookiesState();
  }, [deleteCookie, revalidateCookiesState]);

  return { setNamespaceId, resetNamespaceId, namespaceId, revalidateNamespaceId: revalidateCookiesState };
};

export default useNamespaceId;
